<template>
  <div class="dwp-rounded-md dwp-p-4" :class="classes">
    <div class="dwp-flex">
      <div class="dwp-flex-shrink-0">
        <CheckIcon v-if="type == 'success'" class="dwp-h-5 dwp-w-5 dwp-opacity-50" />
        <AlertCircleIcon v-else-if="type == 'warning'" class="dwp-h-5 dwp-w-5 dwp-opacity-50" />
        <XCircleIcon v-else class="dwp-h-5 dwp-w-5 dwp-opacity-50" />
      </div>
      <div class="dwp-ml-3 dwp-leading-5 dwp-text-sm">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { AlertCircleIcon, XCircleIcon, CheckIcon } from "vue-feather-icons";

export default {
  components: {
    XCircleIcon,
    AlertCircleIcon,
    CheckIcon,
  },

  props: {
    type: String,
  },

  computed: {
    classes() {
      switch (this.type) {
        case "success":
          return "dwp-bg-green-100 dwp-text-green-800";
          break;
        case "warning":
          return "dwp-bg-yellow-100 dwp-text-yellow-800";
          break;
        default:
          return "dwp-bg-red-100 dwp-text-red-800";
          break;
      }
    },
  },
};
</script>